import React from 'react'

import { FormattedNumber, useIntl } from 'react-intl'

import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

interface BidHistoryCardProps {
  createdAt: string
  price: number
  currency: string
  userName: string
}

const BidHistoryCard: RFC<BidHistoryCardProps> = ({
  createdAt,
  price,
  currency,
  userName
}) => {
  const intl = useIntl()

  const date = intl.formatDate(createdAt, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })

  return (
    <Stack
      direction="row"
      sx={{ justifyContent: 'space-between', alignItems: 'center' }}
    >
      <Stack direction="column">
        <Text variant="h3" sx={{ color: 'primary.dark', fontWeight: 500 }}>
          <FormattedNumber style="currency" value={price} currency={currency} />
        </Text>

        <Text variant="body2" sx={{ color: 'primary.dark' }}>
          {userName}
        </Text>
      </Stack>

      <Text variant="subtitle1" sx={{ color: 'text.third' }}>
        {date}
      </Text>
    </Stack>
  )
}
export default BidHistoryCard
